<template>
    <div>
      <b-form-group label="Period" label-for="category">
        <b-form-input
          id="category"
          v-model="category"
          type="text"
          placeholder="Enter Name"
          required
        ></b-form-input>
      </b-form-group>
      <div v-for="(card, cardIndex) in cards" :key="cardIndex" class="mb-3">
        <b-card>
          <b-row>
            <b-col cols="12" md="6" lg="2">
              <b-form-group label="Name" label-for="name-input">
                <b-form-input
                  id="name-input"
                  v-model="card.columns[0].name"
                  type="text"
                  placeholder="Enter Name"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
  
            <b-col
              cols="12"
              md="6"
              lg="2"
             v-for="(col, colIndex) in card.columns.slice(1, 5)"
              :key="colIndex"
              class="mb-2"
            >
            <div>
              <strong>Q{{ colIndex + 1 }}</strong>
            </div>
              <b-form-group label="Budget" label-for="budget-input">
                <b-form-input
                  id="budget-input"
                  v-model="col.budget"
                  type="number"
                  placeholder="Enter Budget"
                  required
                   @input="updateTotal(cardIndex)"
                ></b-form-input>
              </b-form-group>
              <b-form-group label="Actual" label-for="actual-input">
                <b-form-input
                  id="actual-input"
                  v-model="col.actual"
                  type="number"
                  placeholder="Enter Actual"
                  required
                   @input="updateTotal(cardIndex)"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6" lg="2">
              <div><strong>Y</strong></div>
              <b-form-group label="Budget" label-for="y-budget-input">
                <b-form-input
                  id="y-budget-input"
                  v-model="card.columns[5].budget"
                  type="number"
                  readonly
                ></b-form-input>
              </b-form-group>
              <b-form-group label="Actual" label-for="y-actual-input">
                <b-form-input
                  id="y-actual-input"
                  v-model="card.columns[5].actual"
                  type="number"
                  readonly
                ></b-form-input>
              </b-form-group>
            </b-col>
  
            <b-col cols="12" md="6" lg="2">
              <b-button
                variant="danger"
                class="mt-4"
                @click="deleteCard(cardIndex)"
                block
              >
              Remove
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </div>
  
      <div class="text-right mt-3">
        <b-button variant="primary" @click="addCard">Add</b-button>
      </div>
      <div class="text-right mt-3">
        <b-button variant="primary" @click="submitBudget">Update</b-button>
      </div>
    </div>
  </template>
  
  <script>
  import { BCard, BRow, BCol, BFormGroup, BFormInput, BButton } from "bootstrap-vue";
  import { mapActions } from "vuex";
  import Swal from "sweetalert2";
  
  export default {
    components: {
      BCard,
      BRow,
      BCol,
      BFormGroup,
      BFormInput,
      BButton,
    },
    data() {
      return {
        category: "",
        cards: [],
        budgetId: null,
      };
    },
    methods: {
      ...mapActions("budgetModule", ["getBudgetByIdListAction", "updateBudgetAction"]),
      updateTotal(cardIndex) {
  const card = this.cards[cardIndex];

  // Ensure values are treated as numbers, defaulting to 0 if empty
  const budgetSum = card.columns.slice(1, 5).reduce((sum, col) => sum + (parseFloat(col.budget) || 0), 0);
  const actualSum = card.columns.slice(1, 5).reduce((sum, col) => sum + (parseFloat(col.actual) || 0), 0);

  this.$set(card.columns[5], "budget", budgetSum);
  this.$set(card.columns[5], "actual", actualSum);
},
      async fetchBudgetData() {
        try {
          Swal.fire({
            title: "Loading...",
            text: "Fetching budget details...",
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });
  
          const response = await this.getBudgetByIdListAction(this.budgetId);
          console.log("Response from getBudgetByIdListAction:", response);
          Swal.close();
  
          if (response && response.success) {
            const budget = response.result;
            this.category = budget.category;
            this.cards = budget.budgetDetails.map((detail) => ({
              columns: [
                { name: detail.name },
                { budget: detail.q1, actual: detail.q1V },
                { budget: detail.q2, actual: detail.q2V },
                { budget: detail.q3, actual: detail.q3V },
                { budget: detail.q4, actual: detail.q4V },
                { budget: detail.y, actual: detail.yv },
              ],
            }));
          } else {
            throw new Error("Failed to fetch budget data.");
          }
        } catch (error) {
          Swal.fire({
            title: "Error",
            text: "Unable to fetch budget details.",
            icon: "error",
            confirmButtonText: "OK",
          });
          console.error(error);
        }
      },
      async submitBudget() {
        if (!this.category || this.cards.some(card => !card.columns[0].name || card.columns.slice(1, 5).some(col => col.budget === null || col.budget === "" || col.actual === null || col.actual === ""))) {
        Swal.fire({
          title: "Error",
          text: "Please fill all required fields!",
          icon: "warning",
          confirmButtonText: "OK",
        });
        return;
      }
      const budgetSum = this.cards.reduce((sum, card) => sum + card.columns[5].budget, 0);
      const actualSum = this.cards.reduce((sum, card) => sum + card.columns[5].actual, 0);
        const payload = {
          id: this.budgetId, 
          actualAmount: actualSum,
          budgetAmount: budgetSum,
          budgetDetails: this.cards.map((card) => ({
            name: card.columns[0].name,
            q1: parseFloat(card.columns[1]?.budget || 0),
            q1V: parseFloat(card.columns[1]?.actual || 0),
            q2: parseFloat(card.columns[2]?.budget || 0),
            q2V: parseFloat(card.columns[2]?.actual || 0),
            q3: parseFloat(card.columns[3]?.budget || 0),
            q3V: parseFloat(card.columns[3]?.actual || 0),
            q4: parseFloat(card.columns[4]?.budget || 0),
            q4V: parseFloat(card.columns[4]?.actual || 0),
            y: parseFloat(card.columns[5]?.budget || 0),
            yv: parseFloat(card.columns[5]?.actual || 0),
          })),
          category: this.category || "DEFAULT",
        };
  
        try {
          Swal.fire({
            title: "Processing...",
            text: "Please wait while we update the budget data.",
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });
  
          const response = await this.updateBudgetAction(payload); // Call updateBudgetAction
          Swal.close();
  
          if (response && response.success) {
            Swal.fire({
    title: "Success",
    text: "Budget updated successfully!",
    icon: "success",
    confirmButtonText: "OK",
  }).then(() => {
    this.$router.push("/accounting-budget");
  });
          } else {
            throw new Error("Failed to update budget.");
          }
        } catch (error) {
          Swal.fire({
            title: "Error",
            text: "Failed to update budget. Please try again.",
            icon: "error",
            confirmButtonText: "OK",
          });
          console.error(error);
        }
      },
      addCard() {
        this.cards.push({
          columns: [
            { name: "" },
            { budget: "", actual: "" },
            { budget: "", actual: "" },
            { budget: "", actual: "" },
            { budget: "", actual: "" },
            { budget: "", actual: "" },
          ],
        });
      },
      deleteCard(cardIndex) {
        if (this.cards.length > 1) {
          this.cards.splice(cardIndex, 1);
        } else {
          Swal.fire({
            title: "Error",
            text: "Cannot delete the last card!",
            icon: "warning",
            confirmButtonText: "OK",
          });
        }
      },
    },
    async mounted() {
      const { id } = this.$route.params; // Assuming `id` is passed as a route param
      if (id) {
        this.budgetId = id;
        await this.fetchBudgetData();
      }
    },
  };
  </script>
  
  <style scoped>
  .mb-2 {
    margin-bottom: 0.5rem;
  }
  </style>
  